import React from 'react'
import Logo from './img/logo/TC-LOGO.png';
import './EditProfile.css';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

function EditProfile() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [counter, setCounter] = useState(0);
  const history = useHistory();

  const onSubmit = () =>{}

  return (
    <div className='e__profile'>
        <div className='e__profile_logo'>
            <Link to='/'>
                <img className='logo' src={Logo}/>
            </Link>    
        </div>
        <div className='e__profile_text'>
            <h2>Sign Up</h2>
            <h3>Create your Toy City Account</h3>
        </div>
        <div className='e__profile__blueSide'></div>
        <div className='e__profile__center'>
            <input type="text" id='__307' value={email} onChange={e => setEmail(e.target.value)} placeholder="Email"></input>
            <div className='e__profile__error' id='307'><label id='424'>Email invalid</label></div>
            <input type="password" id='__707' value={password} onChange={e => setPassword(e.target.value)} placeholder="Password"></input>
            <Link to='/changepassword'><div className='e__profile__forgot'><label className='e__profile_goto'>Forgot Password?</label></div></Link>
            <button onClick={onSubmit}>Apply changes</button>
        </div>
    </div>
  )
}

export default EditProfile